import {
    MDBAlert, MDBBtn,
    MDBIcon,
    MDBModalFooter,
    MDBSpinner
} from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router';
import { unAssignPhoneDevice } from "../../../apiclients/streamsapi_bridge.js";

function UnassignDevices(props) {
    const [isloading, setIsloading] = useState(false);

    const navigate = useNavigate();
    console.log("[UnassignDevices] params recieved : " + props);
    console.log(props.param);
    let unassignDeviceDetails = props.param;
    const { t, i18n } = useTranslation();
    const [isError, setError] = useState(false);
    const handlesubmit = async (macAdress, deviceId, provisioning_method, agentId) => {
        console.log("Request came to [handlesubmit] for unassign device : " + macAdress + "agentId " + agentId);
        let params = {};
        params.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        if (provisioning_method == 1 || provisioning_method == 3) {   //Auto Unassign
            params.reqid = 20;
            params.device_macadress = macAdress;
        } else if (provisioning_method == 2) { //Maual remove
            params.reqid = 30;
            params.deviceId = deviceId;
            params.provisioning_method = provisioning_method;
            params.agentid = agentId;
            params.device_uuid = unassignDeviceDetails.deviceUUID;
        }
        setIsloading(true);
        let servres = await unAssignPhoneDevice(JSON.parse(sessionStorage.getItem("admin_session")).siteid, params);
        if (!servres.ok) {
            console.log("Network response was not ok in [unassignDevice.js]");
            setTimeout(() => {
                setIsloading(false);
            }, 1000)
            setError(true);
        } else {
            setTimeout(() => {
                setIsloading(false);
            }, 1000)
            props.onClose();
            // if (provisioning_method == 1) {
            //     localStorage.setItem("s_message","Device Unassigned successfully.");
            // } else {
            localStorage.setItem("s_message", "Device Unassigned successfully. Please reboot the device.");
            // }
            window.location.href = "/pslanding?tab=tab2";
            navigate("/pslanding", {
                state: { tab: "tab2" },
            });
            window.location.reload();
        }

    }


    return (
        <>
            {isError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={100000}
                >
                    {t("Provisioning_Error_Aleart")}
                </MDBAlert>
            )}
            {unassignDeviceDetails.provisioning_method == 2 ? (
                <div className="pb-2">
                    Are you sure you want to remove <span className="fw-bold">{unassignDeviceDetails.PhoneName} - {unassignDeviceDetails.Designation}</span>?
                </div>
            ) : (
                <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                    <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                    <span>
                        Are you sure you want to unassign <span className="fw-bold">{unassignDeviceDetails.Model} ({unassignDeviceDetails.MacAddress.trim()})</span> for <span className="fw-bold">{unassignDeviceDetails.PhoneName} - {unassignDeviceDetails.Designation}</span>?
                    </span>
                </div>
            )}
            <MDBModalFooter className='p-0 mt-3 pt-2'>
                <MDBBtn
                    color="secondary"
                    className="cancle-btn"
                    onClick={(e) => props.onClose(e)}
                >
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={() => handlesubmit(unassignDeviceDetails.MacAddress.trim(), unassignDeviceDetails.deviceId, unassignDeviceDetails.provisioning_method, unassignDeviceDetails.agentId)}>
                    {unassignDeviceDetails.provisioning_method == 2 ? (
                        t("remove")
                    ) : (
                        t("unassign")
                    )}
                </MDBBtn>
            </MDBModalFooter>
            {
                isloading && (
                    <div>
                        <div className="loadingclass-popup"></div>
                        <div className="popup-bg-loader loader_align">
                            <MDBBtn disabled>
                                <MDBSpinner
                                    size="sm"
                                    role="status"
                                    tag="span"
                                    className="me-2"
                                />
                                Loading...
                            </MDBBtn>
                        </div>
                    </div>
                )
            }
        </>
    );
}
export default UnassignDevices;